import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { CustomDataFormValues } from '@/utils/customDataForm';

export const isCandidateProfileEditAtom = atom<boolean>(false);

export const candidateScreenType = atomWithStorage<'list' | 'board'>(
  'candidateScreenType',
  'list',
  undefined,
  {
    getOnInit: true,
  }
);

/**
 * 「ファイルから登録」モーダルでの書類解析結果。
 * モーダルは直接候補者を作成せず、この解析結果を保持したまま新規登録フォーム
 * （/agent/candidates/new）へ遷移する。作成（POST）はフォーム側でのみ行う。
 */
export type CandidateResumeParseResult = {
  /** 解析結果 or ユーザー入力の氏名 */
  name: string | null;
  /** RHF 形式の customData レコード（履歴書・職歴書をマージ済み） */
  customData: CustomDataFormValues;
  /** 解析済み書類（履歴書・職歴書）blob の signed_id 一覧 */
  blobSignedIds: string[];
};

/**
 * モーダルから新規登録フォームへ書類解析結果を引き継ぐための一時 atom。
 * フォーム側は初期値への反映が完了したら null にクリアする。
 */
export const candidateResumeParseResultAtom = atom<CandidateResumeParseResult | null>(null);

export const candidateInterviewTranscriptAtom = atom<string | null>(null);
